// Panel dédié OpenCode — pattern network (1 fichier fin par CLI).
import type { Component } from "solid-js";
import { registerPanel } from "@/panel-registry";
import { CliPanel } from "./cli/cli-panel";

const OpenCodeCliPanel: Component = () => <CliPanel cli="opencode" />;

registerPanel("cli-opencode", OpenCodeCliPanel);
export default OpenCodeCliPanel;
